import { formatRoleLabel } from '@/shared/constants/role-labels';

/** Badge variant per role, so the table and the card badge a role the same way. */
export const roleColors: Record<string, 'default' | 'secondary' | 'outline'> = {
  ADMIN: 'default',
  MANAGER: 'secondary',
  AGENT: 'outline',
  CANDIDATE: 'outline',
  REFEREE: 'outline',
};

/**
 * Label for a role badge. Delegates to the shared map so a badge and the role
 * switcher can never drift apart — the raw REFEREE enum stays a wire value.
 */
export const roleBadgeLabel = formatRoleLabel;
